module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_1513.0337f62b.jpg";